import { action } from "satcheljs";

interface DrawerPaneClosedActionMessage {
    paneId: string;
    targetWindow?: Window;
}

export const drawerPaneClosed: (paneId: string, targetWindow?: Window) => DrawerPaneClosedActionMessage = action("DrawerPaneClosed", (paneId: string, targetWindow?: Window): DrawerPaneClosedActionMessage => ({
    paneId,
    targetWindow,
}));
